interface PauseButtonSVGProps {
  color: string;
  style: React.CSSProperties;
}

const PauseButtonSVG = ({ color, style }: PauseButtonSVGProps) => (
  <svg
    style={style}
    width="120"
    height="120"
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="60"
      cy="60"
      r="56.3636"
      stroke="#D9D9D9"
      strokeWidth="7.27273"
    />
    <path
      d="M51 42V78H42V42H51ZM51 37.5H42C40.8065 37.5 39.6619 37.9741 38.818 38.818C37.9741 39.6619 37.5 40.8065 37.5 42V78C37.5 79.1935 37.9741 80.3381 38.818 81.182C39.6619 82.0259 40.8065 82.5 42 82.5H51C52.1935 82.5 53.3381 82.0259 54.182 81.182C55.0259 80.3381 55.5 79.1935 55.5 78V42C55.5 40.8065 55.0259 39.6619 54.182 38.818C53.3381 37.9741 52.1935 37.5 51 37.5ZM78 42V78H69V42H78ZM78 37.5H69C67.8065 37.5 66.6619 37.9741 65.818 38.818C64.9741 39.6619 64.5 40.8065 64.5 42V78C64.5 79.1935 64.9741 80.3381 65.818 81.182C66.6619 82.0259 67.8065 82.5 69 82.5H78C79.1935 82.5 80.3381 82.0259 81.182 81.182C82.0259 80.3381 82.5 79.1935 82.5 78V42C82.5 40.8065 82.0259 39.6619 81.182 38.818C80.3381 37.9741 79.1935 37.5 78 37.5Z"
      fill={color}
    />
  </svg>
);

export default PauseButtonSVG;
